import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import CloseIcon from '@mui/icons-material/Close';

export const TITLE_BAR_ACTIONS = (onCopyAll, onClear, onClose) => [
    { icon: <ContentCopyIcon sx={{ fontSize: 16 }} />, title: 'Copy All', onClick: onCopyAll },
    { icon: <DeleteSweepIcon sx={{ fontSize: 16 }} />, title: 'Clear', onClick: onClear },
    { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
